import Notices from './Notices.jsx';

export default Notices;
